const state = {
  currentPage: 1,
  totalPages: 1,
  itemsPerPage: 15,
  totalVisible: 7,
}

const getters = {
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  itemsPerPage: (state) => state.itemsPerPage,
  totalVisible: (state) => state.totalVisible,
}

const mutations = {
  setCurrentPage: (state, currentPage) => {
    state.currentPage = currentPage
  },

  setTotalPages: (state, totalPages) => {
    state.totalPages = Math.ceil(totalPages / state.itemsPerPage)
  },

  setItemsPerPage: (state, itemsPerPage) => {
    state.itemsPerPage = itemsPerPage
  },
}

export default {
  state,
  getters,
  mutations,
}
